<template>
    <div :class="['group_detail',isRunInWeChat && 'active']" >
        <titleBar :title="title" v-if="!isRunInWeChat"></titleBar>
        <img class="header" :src="productData.headPhotoUrl" alt="">
        <isGroup 
            v-if="isGroup" 
            :productData="productData"
            :department="department"
        ></isGroup>
        <noGroup 
            v-else
            :productData="productData"
            :groupInfoId="groupInfoId"
            :groupId="groupId"
        ></noGroup>
    </div>
</template>

<script>
import utils from "@/assets/js/utils";
import isGroup from "./components/is_group.vue";
import noGroup from "./components/no_group.vue";
import titleBar from "@/components/common/titleBar.vue";
import { isRunInWeChat } from "../../utils/env";

export default {
  name: "group_detail",
  data() {
    return {
      isGroup: false,
      // productData: {"buttonStatus":7,"groupInfo":{"groupStatus":0,"headList":[],"groupProducer":"","headUrl":"","endTime":0,"courseTime":"","leftPeopleNumber":0},"groupId":"52","department":"3","productId":"2116","oldProductId":"2111","groupName":"小象科学团购测试lyq团购","groupDesc":"小象科学团购测试lyq","buyerCount":"3","groupPrice":"1.00","originPrice":"1.00","groupRule":["rule2","规则1","规则2"],"groupDescImgList":null,"serviceList":[{"title":"title","desc":"desc"},{"title":"服务标题1","desc":"服务说明1"},{"title":"服务标题2","desc":"服务说明2"}],"groupNumber":500,"grade":"","courseTimes":[],"headPhotoUrl":"http://appd.knowbox.cn/ss/images/activity/popup/p_science.png","bubbleList":[{"username":"盛**","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/201506/20909_93836e9a-4bb1-45f8-99e5-55e6b39c9e14.jpg"},{"username":"温**","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/20154/20154131737292597092_small.jpg"},{"username":"高*","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/20160506/20898_c537e1d7-a8f1-491c-a202-add5149e984e.jpg"},{"username":"王**","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/201604/20966_439ae695-8de2-478a-8db9-d1dab8b27b00.jpg"},{"username":"陈*","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/201504/20946_7e3819dd-be22-4c4a-ae75-cd7eddeab6bd.jpg"},{"username":"周**","headPhoto":"https://susuanqiniu.knowbox.cn/20160905/20948/20160905191984_488.jpg"},{"username":"赵**","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/20160617/20902_5b20daef-b857-4061-b6e3-691a66bfab3b.jpg"},{"username":"尹**","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/201509/20963_ec1d225d-c556-4216-bb7f-d0cf51ef202e.jpg"},{"username":"郜**","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/201504/20976_a892234e-2b22-46da-beee-e8d00e1480ba.jpg"},{"username":"崔**","headPhoto":"https://susuanqiniu.knowbox.cn/headPhoto/201504/20904_f7423b26-ef33-43b2-8808-8526b40ff4f3.jpg"}],"groupList":["https://susuanqiniu.knowbox.cn/headPhoto/201602/21009_895ac4d6-0aa5-41c0-bf94-67c838c3bde4.jpg","https://susuanqiniu.knowbox.cn/headPhoto/20160506/20898_c537e1d7-a8f1-491c-a202-add5149e984e.jpg","https://susuanqiniu.knowbox.cn/headPhoto/201504/20954_b1ee778f-f7ca-4d4f-b577-03d4cb356345.jpg"],"shareImgUrl":"http://appd.knowbox.cn/ss/images/activity/popup/p_science.png","shareTitle":"分享标题","shareDesc":"分享描述","needLogin":0},
      productData:{},
      department: '',
      isRunInWeChat: isRunInWeChat(),
      title:'拼团详情',
    };
  },
  components: {
    isGroup,
    noGroup,
    titleBar
  },
  created: function() {
    this.token = utils.getQueryString("token");
    this.source = utils.getQueryString("source");
    this.version = utils.getQueryString("version");
    this.groupInfoId = utils.getQueryString("groupInfoId");
    this.groupId = utils.getQueryString("groupId");
    this.department = utils.getQueryString("department");
    console.log('---------------------');
    this.initData();
    
  },
  methods: {
    initData() {
      const { token, source, groupInfoId, groupId } = this;
      this.$api
        .getProductDetail({
          token,
          source,
          groupInfoId,
          groupId
        })
        .then(data => {
          this.isGroup = data.groupInfo.leftPeopleNumber > 0 ? false : true;
          this.productData = data; 
          this.$wxShare({
            title: data.shareTitle,
            desc: data.shareDesc,
            link: window.location.origin + window.location.pathname + '#/group_buy/h5_detail?' + 'groupInfoId='+ this.groupInfoId +'&groupId='+ this.groupId,
            imgUrl: data.shareImgUrl
          })        
        }).catch((res)=>{
          this.$toast(res.msg);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.group_detail {
  width: 100%;
  background: #fff;
  min-height: calc(100vh - .88rem);
  margin-top: .88rem;
  .header {
    width: 100%;
    // height: 4.8rem;
    display: block;
  }
  &.active{
    margin-top: 0rem;
  }
}
</style>